import { render } from "./WeekPicker.vue?vue&type=template&id=fc8e9eda"
import script from "./WeekPicker.vue?vue&type=script&lang=js"
export * from "./WeekPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__